import locale1b218780 from '../../lang/de-DE.js'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"de"},
  vueI18nLoader: false,
  locales: [{"code":"de","iso":"de-DE","file":"de-DE.js","name":"Deutsch","domain":"www.caravanmarkt24.de"},{"code":"en","iso":"en-US","file":"en-US.js","name":"English","domain":"www.caravanmarkt24.com"},{"code":"nl","iso":"nl","file":"nl-NL.js","name":"Nederlands","domain":"www.caravanmarkt24.nl"},{"code":"sv","iso":"sv-SE","file":"sv-SE.js","name":"Svenska","domain":"www.caravanmarkt24.se"},{"code":"da","iso":"da-DK","file":"da-DK.js","name":"Dansk","domain":"www.caravanmarkt24.dk"},{"code":"pl","iso":"pl-PL","file":"pl-PL.js","name":"Polski","domain":"www.caravanmarkt24.pl"},{"code":"es","iso":"es-ES","file":"es-ES.js","name":"Español","domain":"www.caravanmarkt24.es"},{"code":"cs","iso":"cs-CZ","file":"cs-CZ.js","name":"Ceština","domain":"www.caravanmarkt24.cz"}],
  defaultLocale: "de",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "lang/",
  rootRedirect: null,
  detectBrowserLanguage: false,
  differentDomains: true,
  baseUrl: function baseUrl(context) {
      if (process.server) {
        return 'https://' + context.req?.headers?.host;
      } else {
        return window.location.origin;
      }
    },
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  seo: false,
  normalizedLocales: [{"code":"de","iso":"de-DE","file":"de-DE.js","name":"Deutsch","domain":"www.caravanmarkt24.de"},{"code":"en","iso":"en-US","file":"en-US.js","name":"English","domain":"www.caravanmarkt24.com"},{"code":"nl","iso":"nl","file":"nl-NL.js","name":"Nederlands","domain":"www.caravanmarkt24.nl"},{"code":"sv","iso":"sv-SE","file":"sv-SE.js","name":"Svenska","domain":"www.caravanmarkt24.se"},{"code":"da","iso":"da-DK","file":"da-DK.js","name":"Dansk","domain":"www.caravanmarkt24.dk"},{"code":"pl","iso":"pl-PL","file":"pl-PL.js","name":"Polski","domain":"www.caravanmarkt24.pl"},{"code":"es","iso":"es-ES","file":"es-ES.js","name":"Español","domain":"www.caravanmarkt24.es"},{"code":"cs","iso":"cs-CZ","file":"cs-CZ.js","name":"Ceština","domain":"www.caravanmarkt24.cz"}],
  localeCodes: ["de","en","nl","sv","da","pl","es","cs"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "d",
  3: "e",
  4: "-",
  5: "D",
  6: "E",
  7: ".",
  8: "j",
  9: "s",
  10: "\"",
  11: ":",
  12: "\"",
  13: ".",
  14: ".",
  15: "/",
  16: "l",
  17: "a",
  18: "n",
  19: "g",
  20: "/",
  21: "d",
  22: "e",
  23: "-",
  24: "D",
  25: "E",
  26: ".",
  27: "j",
  28: "s",
  29: "\"",
  30: ",",
  31: "\"",
  32: "e",
  33: "n",
  34: "-",
  35: "U",
  36: "S",
  37: ".",
  38: "j",
  39: "s",
  40: "\"",
  41: ":",
  42: "\"",
  43: ".",
  44: ".",
  45: "/",
  46: "l",
  47: "a",
  48: "n",
  49: "g",
  50: "/",
  51: "e",
  52: "n",
  53: "-",
  54: "U",
  55: "S",
  56: ".",
  57: "j",
  58: "s",
  59: "\"",
  60: ",",
  61: "\"",
  62: "n",
  63: "l",
  64: "-",
  65: "N",
  66: "L",
  67: ".",
  68: "j",
  69: "s",
  70: "\"",
  71: ":",
  72: "\"",
  73: ".",
  74: ".",
  75: "/",
  76: "l",
  77: "a",
  78: "n",
  79: "g",
  80: "/",
  81: "n",
  82: "l",
  83: "-",
  84: "N",
  85: "L",
  86: ".",
  87: "j",
  88: "s",
  89: "\"",
  90: ",",
  91: "\"",
  92: "s",
  93: "v",
  94: "-",
  95: "S",
  96: "E",
  97: ".",
  98: "j",
  99: "s",
  100: "\"",
  101: ":",
  102: "\"",
  103: ".",
  104: ".",
  105: "/",
  106: "l",
  107: "a",
  108: "n",
  109: "g",
  110: "/",
  111: "s",
  112: "v",
  113: "-",
  114: "S",
  115: "E",
  116: ".",
  117: "j",
  118: "s",
  119: "\"",
  120: ",",
  121: "\"",
  122: "d",
  123: "a",
  124: "-",
  125: "D",
  126: "K",
  127: ".",
  128: "j",
  129: "s",
  130: "\"",
  131: ":",
  132: "\"",
  133: ".",
  134: ".",
  135: "/",
  136: "l",
  137: "a",
  138: "n",
  139: "g",
  140: "/",
  141: "d",
  142: "a",
  143: "-",
  144: "D",
  145: "K",
  146: ".",
  147: "j",
  148: "s",
  149: "\"",
  150: ",",
  151: "\"",
  152: "p",
  153: "l",
  154: "-",
  155: "P",
  156: "L",
  157: ".",
  158: "j",
  159: "s",
  160: "\"",
  161: ":",
  162: "\"",
  163: ".",
  164: ".",
  165: "/",
  166: "l",
  167: "a",
  168: "n",
  169: "g",
  170: "/",
  171: "p",
  172: "l",
  173: "-",
  174: "P",
  175: "L",
  176: ".",
  177: "j",
  178: "s",
  179: "\"",
  180: ",",
  181: "\"",
  182: "e",
  183: "s",
  184: "-",
  185: "E",
  186: "S",
  187: ".",
  188: "j",
  189: "s",
  190: "\"",
  191: ":",
  192: "\"",
  193: ".",
  194: ".",
  195: "/",
  196: "l",
  197: "a",
  198: "n",
  199: "g",
  200: "/",
  201: "e",
  202: "s",
  203: "-",
  204: "E",
  205: "S",
  206: ".",
  207: "j",
  208: "s",
  209: "\"",
  210: ",",
  211: "\"",
  212: "c",
  213: "s",
  214: "-",
  215: "C",
  216: "Z",
  217: ".",
  218: "j",
  219: "s",
  220: "\"",
  221: ":",
  222: "\"",
  223: ".",
  224: ".",
  225: "/",
  226: "l",
  227: "a",
  228: "n",
  229: "g",
  230: "/",
  231: "c",
  232: "s",
  233: "-",
  234: "C",
  235: "Z",
  236: ".",
  237: "j",
  238: "s",
  239: "\"",
  240: "}",
}

export const localeMessages = {
  'de-DE.js': () => Promise.resolve(locale1b218780),
  'en-US.js': () => import('../../lang/en-US.js' /* webpackChunkName: "lang-en-US.js" */),
  'nl-NL.js': () => import('../../lang/nl-NL.js' /* webpackChunkName: "lang-nl-NL.js" */),
  'sv-SE.js': () => import('../../lang/sv-SE.js' /* webpackChunkName: "lang-sv-SE.js" */),
  'da-DK.js': () => import('../../lang/da-DK.js' /* webpackChunkName: "lang-da-DK.js" */),
  'pl-PL.js': () => import('../../lang/pl-PL.js' /* webpackChunkName: "lang-pl-PL.js" */),
  'es-ES.js': () => import('../../lang/es-ES.js' /* webpackChunkName: "lang-es-ES.js" */),
  'cs-CZ.js': () => import('../../lang/cs-CZ.js' /* webpackChunkName: "lang-cs-CZ.js" */),
}
